/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import {
  CircularProgress,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { PlusIcon } from '@phosphor-icons/react';
import { Layout, Table, DrawerRight } from '@orientaction/components';
import { useAlert } from '@orientaction/hooks';
import {
  columnsConsultations,
  CONSULTATION_TYPE_CONFIG,
  CONSULTATION_TYPE_DEFAULT_CONFIG,
  getFromLS,
  formatDate,
  calculateAge,
} from '@orientaction/utils';
import { userService, MajorTest, aiService, adminService } from '@orientaction/services';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useStyles } from './style';
import { useConsultationData } from '../../../hooks/useConsultationData';
import ConsultationNavigation from '../../../components/ConsultationNavigation';
import { ReactComponent as Check } from '../../../Asset/svg/check.svg';
import { ReactComponent as Close } from '../../../Asset/svg/close.svg';
import { ReactComponent as ImportIcon } from '../../../Asset/svg/import.svg';
import { ReactComponent as ExportIcon } from '../../../Asset/svg/export.svg';
import { ReactComponent as TrashIcon } from '../../../Asset/svg/delete.svg';
import { ReactComponent as VisibilityIcon } from '../../../Asset/svg/eye.svg';

const capitalizeFirstLetter = (text: string | undefined | null): string => {
  if (!text || typeof text !== 'string') return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const ResultatBeneficiaire = ({ width }: any) => {
  // states
  const [consultations, setConsultations] = useState<
    Array<Array<{ value: string | React.ReactNode }>>
  >([]);
  const [loading, setLoading] = useState(false);
  const [beneficiaryData, setBeneficiaryData] = useState<any>(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [testStatus, setTestStatus] = useState<any>(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [fileError, setFileError] = useState<string>('');
  const [currentPage, setCurrentPage] = useState(0);

  // hooks
  const classes = useStyles();
  const history = useHistory();
  const dataParams: any = useParams();
  const { id: beneficiaryId } = dataParams;

  const alert = useAlert();
  const token = getFromLS('userToken') || '';

  // Consultation data management with sessionStorage
  const {
    consultationData,
    currentStep,
    validation,
    isComplete,
    setCurrentStep,
    updateBeneficiaryInfo,
    updateBeneficiarySituation,
    updateConsultationType,
    updateContextualData,
    updateSelectedQuery,
    initializeConsultation,
    clearConsultation,
    canNavigateToStep,
    goToNextStep,
    goToPreviousStep,
  } = useConsultationData(beneficiaryId);

  // Extract data for easier access
  const { beneficiaryInfo, beneficiarySituation, consultationType, contextualData, selectedQuery } =
    consultationData;

  const [cvFile, setCvFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getUserConsultation = async () => {
    if (!beneficiaryId || !token) return;

    try {
      setDataLoading(true);
      setLoading(true);

      const response = await userService.getUserById({ userId: beneficiaryId, token });
      setBeneficiaryData(response?.data);

      await fetchConsultations();
    } catch (error) {
      console.error('Error fetching beneficiary data:', error);
      alert.openSimpleAlert('Erreur lors du chargement des informations du bénéficiaire.');
    } finally {
      setDataLoading(false);
      setLoading(false);
    }
  };

  const openConsultation = (consultation: any) => () => {
    history.push(`/admin/assistant-ia/${beneficiaryId}/consultation/${consultation.id}`);
  };
  const handleDownloadSynthesis = async (consultation: any) => {
    try {
      await aiService.downloadSynthesis(consultation.id);
    } catch (error) {
      console.error('Error downloading synthesis:', error);
      openSnackbar('Erreur lors du téléchargement de la synthèse');
    }
  };

  const fetchConsultations = async () => {
    try {
      const fetchedConsultationDetails = await aiService.getConsultationsByBeneficiary(
        beneficiaryId
      );
      setConsultations(
        fetchedConsultationDetails.map(consultation => [
          { value: consultation.id, onClickAction: openConsultation(consultation) },
          {
            value:
              CONSULTATION_TYPE_CONFIG[
                consultation.consultationType as keyof typeof CONSULTATION_TYPE_CONFIG
              ]?.name,
            onClickAction: openConsultation(consultation),
          },
          {
            value: formatDate(consultation.createdAt),
            onClickAction: openConsultation(consultation),
          },
          {
            value: formatDate(consultation.updatedAt),
            onClickAction: openConsultation(consultation),
          },
          {
            value: consultation.synthesis ? (
              <VisibilityIcon
                onClick={e => {
                  e.stopPropagation();
                  handleDownloadSynthesis(consultation);
                }}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              '-'
            ),
            onClickAction: openConsultation(consultation),
          },
          {
            value: (
              <Button
                variant="outlined"
                onClick={e => {
                  e.stopPropagation();
                  openConsultation(consultation)();
                }}
                className={classes.button}>
                Consulter
              </Button>
            ),
            onClickAction: openConsultation(consultation),
          },
        ])
      );
    } catch (error) {
      console.error('Error fetching consultation details:', error);
    }
  };

  const goBack = () => {
    history.push('/admin/users-resultats?tab=5');
  };

  const handleChangePage = (event: any, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleCreateConsultation = () => {
    const newBeneficiaryInfo = {
      birthDate: beneficiaryData.dayOfBirth,
      gender: beneficiaryData.gender,
      diploma: beneficiaryData.diploma,
      postalCode: beneficiaryData.postal_code,
      city: beneficiaryData.town,
      firstname: beneficiaryData.firstname,
      lastname: beneficiaryData.lastname,
      email: beneficiaryData.email,
    };
    const consultantInfo = {
      firstname: beneficiaryData.upper_hierarchy.firstname,
      lastname: beneficiaryData.upper_hierarchy.lastname,
    };
    initializeConsultation(beneficiaryId, newBeneficiaryInfo, consultantInfo);
    setOpenDrawer(true);
  };

  const callBackDrawer = () => {
    setOpenDrawer(false);
    setCurrentStep(1);
    // Clear consultation data when closing without completing
    clearConsultation();
  };

  const handleUpdateInformation = () => {
    setCurrentStep(2);
  };

  const checkTestCompletion = async () => {
    if (!beneficiaryId || !token) return;

    try {
      const response = await MajorTest.getUserAllTestLatestResult(token, beneficiaryId);
      const testResults = response.data.data;

      const completedTests = {
        harmony: !!testResults.harmonyTestLastResult,
        meaning: !!testResults.meaningTestLastResult,
        needsPro: !!testResults.needsProTestLastResult,
        preference: !!testResults.preferenceTestLastResult,
      };

      const completedCount = Object.values(completedTests).filter(Boolean).length;

      let canCreateConsultation = false;
      let showWarning = false;
      let message = '';

      if (completedCount === 0) {
        // 0/4 tests completed
        canCreateConsultation = false;
        message =
          "Votre bénéficiaire n'a passé aucun test, merci de lui faire passer les tests avant de démarrer une consultation.";
      } else if (completedCount < 4) {
        // 1-3/4 tests completed
        canCreateConsultation = true;
        showWarning = true;
        message =
          "Votre bénéficiaire n'a pas complété tous les tests. Nous vous recommandons de faire passer tous les tests avant votre consultation IA.";
      } else {
        // 4/4 tests completed
        canCreateConsultation = true;
        showWarning = false;
        message = 'Le bénéficiaire a complété tous les tests majeurs.';
      }

      setTestStatus({
        completedCount,
        canCreateConsultation,
        message,
        showWarning,
        completedTests,
      });
    } catch (error) {
      console.error('Error checking test completion:', error);
      setTestStatus({
        canCreateConsultation: false,
        message: 'Erreur lors de la vérification des tests',
        showWarning: false,
      });
    }
  };

  // Dynamic content based on consultation type
  const getContextualDataLabel = () =>
    CONSULTATION_TYPE_CONFIG[consultationType as keyof typeof CONSULTATION_TYPE_CONFIG]?.label ??
    CONSULTATION_TYPE_DEFAULT_CONFIG.label;

  const getContextualDataPlaceholder = () =>
    CONSULTATION_TYPE_CONFIG[consultationType as keyof typeof CONSULTATION_TYPE_CONFIG]
      ?.placeholder ?? CONSULTATION_TYPE_DEFAULT_CONFIG.placeholder;

  // File validation and handling
  const validateFile = (file: File): string | null => {
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const allowedTypes = ['application/pdf'];

    if (!allowedTypes.includes(file.type)) {
      return 'Seuls les fichiers PDF sont acceptés';
    }

    if (file.size > maxSize) {
      return 'Le fichier ne doit pas dépasser 2Mo';
    }

    return null;
  };

  const handleFileSelect = (file: File) => {
    const error = validateFile(file);
    if (error) {
      setFileError(error);
      return;
    }

    setFileError('');
    setCvFile(file);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      handleFileSelect(files[0]);
    }
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files && files.length > 0) {
      handleFileSelect(files[0]);
    }
  };

  const removeFile = () => {
    setCvFile(null);
    setFileError('');
  };

  // Get queries for step 6 based on consultation type
  const getQueriesForConsultationType = () =>
    CONSULTATION_TYPE_CONFIG[consultationType as keyof typeof CONSULTATION_TYPE_CONFIG]?.queries ??
    CONSULTATION_TYPE_DEFAULT_CONFIG.queries;

  useEffect(() => {
    getUserConsultation();
    checkTestCompletion();
  }, []);

  useEffect(() => {
    if (openDrawer) {
      checkTestCompletion();
    }
  }, [openDrawer]);

  useEffect(() => {
    // Reset to first page when consultations data changes
    setCurrentPage(0);
  }, [consultations.length]);

  const saveBeneficiaryInfo = async () => {
    // const response = await adminService.update(
    //   {
    //     id: Number(beneficiaryId),
    //     town: beneficiaryInfo.city,
    //     postal_code: beneficiaryInfo.postalCode,
    //     dayOfBirth: beneficiaryInfo.birthDate,
    //     gender: beneficiaryInfo.gender,
    //     diploma: beneficiaryInfo.diploma,
    //     ...beneficiaryData
    //   },
    //   token
    // );
    setCurrentStep(3);
  };

  return (
    <Layout isaddBackground={true}>
      <div className={classes.container}>
        <button type="button" className={classes.backLink} onClick={goBack}>
          ← Retour
        </button>
        <div className={classes.titleRow}>
          <h1 className={classes.pageTitle}>
            {dataLoading
              ? 'Chargement...'
              : `${beneficiaryData?.firstname || ''} ${beneficiaryData?.lastname || ''}`.trim() ||
                'Bénéficiaire'}
          </h1>
          <Button
            className={classes.actionBtn}
            startIcon={<PlusIcon size={18} />}
            onClick={handleCreateConsultation}>
            Créer une nouvelle consultation
          </Button>
        </div>
        <Grid
          className={classes.detailsContainer}
          container={true}
          direction="row"
          alignItems="center">
          <Grid item={true}>
            <div className={classes.detailsTitle}>Informations sur le bénéficiaire</div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>SEXE</div>
            <div className={classes.infoText}>
              {dataLoading
                ? 'Chargement...'
                : capitalizeFirstLetter(beneficiaryData?.gender) || '-'}
            </div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>AGE</div>
            <div className={classes.infoText}>
              {dataLoading
                ? 'Chargement...'
                : beneficiaryData?.dayOfBirth
                ? `${calculateAge(beneficiaryData.dayOfBirth)} ans`
                : '-'}
            </div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>DIPLÔME</div>
            <div className={classes.infoText}>
              {dataLoading ? 'Chargement...' : beneficiaryData?.diploma || '-'}
            </div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>EMAIL</div>
            <div className={classes.infoText}>
              {dataLoading ? 'Chargement...' : beneficiaryData?.email || '-'}
            </div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>CP</div>
            <div className={classes.infoText}>
              {dataLoading ? 'Chargement...' : beneficiaryData?.postal_code || '-'}
            </div>
          </Grid>
          <Grid item={true} className={classes.infoContainer}>
            <div className={classes.infoTitle}>CONSULTANT</div>
            <div className={classes.infoText}>
              {dataLoading
                ? 'Chargement...'
                : beneficiaryData?.upper_hierarchy
                ? `${beneficiaryData.upper_hierarchy.firstname || ''} ${
                    beneficiaryData.upper_hierarchy.lastname || ''
                  }`.trim()
                : '-'}
            </div>
          </Grid>
        </Grid>

        <div className={classes.tableContainer}>
          <Table
            rowsPerPage={10}
            thead={columnsConsultations}
            bodyData={
              consultations.length > 0
                ? consultations.slice(currentPage * 10, currentPage * 10 + 10)
                : []
            }
            handleChangePage={handleChangePage}
            currentPage={currentPage}
            count={consultations.length}
            pagination={true}
            className={`${classes.consultationTable} ${
              consultations.length === 0 ? classes.emptyTable : ''
            }`}
            load={loading || dataLoading}
            bodyText=""
          />

          {!loading && !dataLoading && consultations.length === 0 && (
            <div className={classes.emptyStateSection}>
              <div className={classes.emptyStateContent}>
                <Typography className={classes.emptyStateTitle}>Aucune consultation</Typography>
                <Typography className={classes.emptyStateSubtitle}>
                  Commencez par créer votre première consultation
                </Typography>
                <Button
                  onClick={handleCreateConsultation}
                  className={classes.actionBtn}
                  startIcon={<PlusIcon size={18} />}>
                  Créer une consultation
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      <DrawerRight
        openDrawer={openDrawer}
        callBack={callBackDrawer}
        titleDrawer="Créer une consultation">
        <div className={classes.modalContentWrapper}>
          {/* Main Content Area */}
          <div className={classes.mainContent}>
            {/* Step Indicator */}
            <div className={classes.stepIndicatorContainer}>
              {[1, 2, 3, 4, 5, 6].map((step, index) => (
                <React.Fragment key={step}>
                  <div
                    className={`${classes.stepCircle} ${
                      step <= currentStep ? classes.stepCircleActive : classes.stepCircleInactive
                    }`}>
                    {step}
                  </div>
                  {index < 5 && <div className={classes.stepConnectorLine} />}
                </React.Fragment>
              ))}
            </div>

            {/* Step 1: Test Verification */}
            {currentStep === 1 && (
              <>
                <Typography className={classes.mainTitle}>
                  Vérifications des 4 tests majeurs
                </Typography>
                <Typography className={classes.subtitle}>
                  Pour initier une consultation avec l&apos;assistant IA, le bénéficiaire doit
                  impérativement avoir complété les 4 tests majeurs d&apos;E-OrientAction.
                </Typography>

                {/* Test Verification List */}
                <div className={classes.testList}>
                  {[
                    { name: 'Test des 10 valeurs Sens®', key: 'meaning' },
                    { name: 'Test des 7 besoins professionnels Needs Pro®', key: 'needsPro' },
                    { name: 'Test des 32 personnalités Préférences®', key: 'preference' },
                    { name: 'Test des 16 soft skills Harmony®', key: 'harmony' },
                  ].map((test, index) => {
                    const isCompleted = testStatus?.completedTests?.[test.key];
                    const noTestsCompleted = testStatus?.completedCount === 0;

                    // Determine styling based on overall completion and individual status
                    let checkboxClass;
                    let nameClass;
                    if (noTestsCompleted) {
                      // All tests show red when none are completed
                      checkboxClass = classes.testCheckboxNotDone;
                      nameClass = classes.testNameNotDone;
                    } else if (isCompleted) {
                      // Individual test is completed
                      checkboxClass = classes.testCheckboxCompleted;
                      nameClass = classes.testNameCompleted;
                    } else {
                      // Individual test is not completed, but others might be
                      checkboxClass = classes.testCheckboxIncomplete;
                      nameClass = classes.testNameIncomplete;
                    }

                    return (
                      <div key={`test-${test.key}`} className={classes.testItem}>
                        <div className={`${classes.testCheckbox} ${checkboxClass}`}>
                          {noTestsCompleted || !isCompleted ? (
                            <Close
                              style={{
                                width: 15,
                                height: 15,
                                color: noTestsCompleted ? 'white' : 'grey',
                              }}
                            />
                          ) : (
                            <Check style={{ width: 15, height: 15, color: 'white' }} />
                          )}
                        </div>
                        <Typography className={`${classes.testName} ${nameClass}`}>
                          {test.name}
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* Step 2: Beneficiary Information */}
            {currentStep === 2 && (
              <>
                <Typography className={classes.mainTitle}>Informations bénéficiaire</Typography>
                <Typography className={classes.subtitle}>
                  Plus l&apos;assistant IA dispose d&apos;informations sur le bénéficiaire, plus son
                  analyse sera fine et ses réponses pertinentes.
                </Typography>

                {/* Form Fields */}
                <div className={classes.formContainer}>
                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Date de naissance</Typography>
                    <input
                      type="date"
                      placeholder="jj/mm/aaaa"
                      className={classes.formInput}
                      value={beneficiaryInfo.birthDate}
                      onChange={e =>
                        updateBeneficiaryInfo({ ...beneficiaryInfo, birthDate: e.target.value })
                      }
                    />
                  </div>

                  {/* Sexe */}
                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Sexe</Typography>
                    <FormControl className={classes.formSelect} variant="outlined">
                      <Select
                        value={beneficiaryInfo.gender?.toLowerCase()}
                        onChange={e =>
                          updateBeneficiaryInfo({
                            ...beneficiaryInfo,
                            gender: e.target.value as string,
                          })
                        }
                        displayEmpty={true}
                        className={classes.selectInput}
                        IconComponent={ExpandMoreIcon}>
                        <MenuItem value="">
                          <span className={classes.placeholder}>Sélectionner</span>
                        </MenuItem>
                        <MenuItem value="homme" data-cy="form-gender-homme">
                          Homme
                        </MenuItem>
                        <MenuItem value="femme" data-cy="form-gender-femme">
                          Femme
                        </MenuItem>
                        <MenuItem value="non binaire">Non binaire</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Diplôme</Typography>
                    <FormControl className={classes.formSelect} variant="outlined">
                      <Select
                        value={beneficiaryInfo.diploma}
                        onChange={e =>
                          updateBeneficiaryInfo({
                            ...beneficiaryInfo,
                            diploma: e.target.value as string,
                          })
                        }
                        displayEmpty={true}
                        className={classes.selectInput}
                        IconComponent={ExpandMoreIcon}>
                        <MenuItem value="Aucun diplôme">Aucun diplôme</MenuItem>
                        <MenuItem value="CAP/BEP">CAP/BEP</MenuItem>
                        <MenuItem value="BAC">BAC</MenuItem>
                        <MenuItem value="BAC+1">BAC+1</MenuItem>
                        <MenuItem value="BAC+2">BAC+2</MenuItem>
                        <MenuItem value="BAC+3">BAC+3</MenuItem>
                        <MenuItem value="BAC+4" data-cy="form-diploma-bac-4">
                          BAC+4
                        </MenuItem>
                        <MenuItem value="BAC+5">BAC+5</MenuItem>
                        <MenuItem value="BAC+6">BAC+6</MenuItem>
                        <MenuItem value="BAC+7">BAC+7</MenuItem>
                        <MenuItem value="BAC+8">BAC+8</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Code postal */}
                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Code postal</Typography>
                    <input
                      type="text"
                      className={classes.formInput}
                      value={beneficiaryInfo.postalCode}
                      onChange={e =>
                        updateBeneficiaryInfo({ ...beneficiaryInfo, postalCode: e.target.value })
                      }
                    />
                  </div>

                  {/* Ville */}
                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>
                      Ville
                      <span className={classes.optionalLabel}>Facultatif</span>
                    </Typography>
                    <input
                      type="text"
                      className={classes.formInput}
                      value={beneficiaryInfo.city}
                      onChange={e =>
                        updateBeneficiaryInfo({ ...beneficiaryInfo, city: e.target.value })
                      }
                    />
                  </div>
                </div>
              </>
            )}

            {/* Step 3: Situation du bénéficiaire */}
            {currentStep === 3 && (
              <>
                <Typography className={classes.mainTitle}>Situation du bénéficiaire</Typography>
                <Typography className={classes.subtitle} style={{ marginBottom: '24px' }}>
                  Afin de mieux adapter l&apos;accompagnement et de proposer des réponses
                  pertinentes via l&apos;assistant IA, il est important d&apos;indiquer la situation
                  actuelle du bénéficiaire.
                </Typography>
                {/* Form Fields */}
                <div className={classes.formContainer}>
                  {/* Type de situation */}
                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Type de situation</Typography>
                    <FormControl className={classes.formSelect} variant="outlined">
                      <Select
                        value={beneficiarySituation.situationType}
                        onChange={e =>
                          updateBeneficiarySituation({
                            ...beneficiarySituation,
                            situationType: e.target.value as string,
                          })
                        }
                        displayEmpty={true}
                        className={classes.selectInput}
                        IconComponent={ExpandMoreIcon}>
                        <MenuItem value="">
                          <span className={classes.placeholder}>Sélectionner</span>
                        </MenuItem>
                        <MenuItem value="handicap">Personnes en situation de handicap</MenuItem>
                        <MenuItem value="maladie-professionnelle">
                          Personnes souffrant de maladie professionnelle ou d&apos;accident du
                          travail
                        </MenuItem>
                        <MenuItem value="demandeur-emploi-longue-duree">
                          Demandeurs d&apos;emploi de longue durée
                        </MenuItem>
                        <MenuItem value="jeunes-neets">
                          Jeunes de moins de 26 ans / NEETs (ni en emploi, ni en formation, ni en
                          études)
                        </MenuItem>
                        <MenuItem value="seniors">Séniors (plus de 45 ou 50 ans)</MenuItem>
                        <MenuItem value="femmes-precarite">
                          Femmes en situation de précarité ou entrepreneures
                        </MenuItem>
                        <MenuItem value="minimas-sociaux">
                          Bénéficiaires de minimas sociaux (RSA, ASS, AAH)
                        </MenuItem>
                        <MenuItem value="main-justice">
                          Personnes placées sous main de justice / sortants de prison
                        </MenuItem>
                        <MenuItem value="refugies">
                          Réfugiés, demandeurs d&apos;asile, primo-arrivants
                        </MenuItem>
                        <MenuItem value="faible-qualification">
                          Personnes ayant un faible niveau de qualification (niveau infra-Bac)
                        </MenuItem>
                        <MenuItem value="licencies-economiques">
                          Salariés licenciés économiques ou en reconversion (ex : PSE, RCC)
                        </MenuItem>
                        <MenuItem value="burn-out">
                          Salariés en situation de burn-out ou inaptitude
                        </MenuItem>
                        <MenuItem value="autres">Autres (précisez)</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Conditional field for "Autres" */}
                  {beneficiarySituation.situationType === 'autres' && (
                    <div className={classes.formField}>
                      <Typography className={classes.formLabel}>Précisez la situation</Typography>
                      <input
                        type="text"
                        className={classes.formInput}
                        value={beneficiarySituation.otherSituation}
                        onChange={e =>
                          updateBeneficiarySituation({
                            ...beneficiarySituation,
                            otherSituation: e.target.value,
                          })
                        }
                        placeholder="Veuillez préciser la situation..."
                      />
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Step 4: Type de consultation */}
            {currentStep === 4 && (
              <>
                <Typography className={classes.mainTitle}>Type de consultation</Typography>
                <Typography className={classes.consultationQuestion}>
                  Quel est le projet principal du bénéficiaire ?
                </Typography>
                <Typography className={classes.subtitle}>
                  Cette information permettra à l’assistant IA de proposer des requêtes et des
                  suggestions personnalisées en lien avec son projet.
                </Typography>
                {/* Form Fields */}
                <div className={classes.formContainer}>
                  <div className={classes.consultationOptions}>
                    {Object.values(CONSULTATION_TYPE_CONFIG).map(option => (
                      <div
                        key={option.value}
                        className={`${classes.consultationCard} ${
                          consultationType === option.value
                            ? classes.consultationCardSelected
                            : classes.consultationCardUnselected
                        }`}
                        onClick={() => updateConsultationType(option.value)}>
                        <Typography className={classes.consultationCardText}>
                          {option.name}
                        </Typography>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

            {/* Step 5: Donnée contextuelle */}
            {currentStep === 5 && (
              <>
                <Typography className={classes.mainTitle}>Donnée contextuelle</Typography>
                <Typography className={classes.subtitle}>
                  Pour que l&apos;assistant IA puisse fournir des réponses précises et adaptées, il
                  est important de compléter les informations contextuelles liées au projet du
                  bénéficiaire.
                </Typography>

                {/* Form Fields */}
                <div className={classes.formContainer}>
                  <Typography className={classes.contextLabel}>
                    {getContextualDataLabel()}
                  </Typography>
                  <div className={classes.formField}>
                    <textarea
                      minLength={6}
                      className={classes.contextTextarea}
                      value={contextualData}
                      onChange={e => updateContextualData(e.target.value)}
                      placeholder="Veuillez décrire le projet du bénéficiaire (6 caractères minimum)"
                      rows={6}
                    />
                  </div>
                </div>
              </>
            )}

            {/* Step 6: Sélectionner une requête */}
            {currentStep === 6 && (
              <>
                <Typography className={classes.mainTitle}>Sélectionner une requête</Typography>
                <Typography className={classes.subtitle}>
                  Sélectionnez la requête à soumettre à l&apos;assistant IA. Il s&apos;agit de la
                  question ou du besoin principal sur lequel l&apos;assistant apportera son analyse.
                </Typography>

                {/* Form Fields */}
                <div className={classes.formContainer}>
                  <div className={classes.consultationOptions}>
                    {getQueriesForConsultationType().map((query, index) => (
                      <div
                        key={query.value}
                        className={`${classes.consultationCard} ${
                          selectedQuery.queryType === query.value
                            ? classes.consultationCardSelected
                            : classes.consultationCardUnselected
                        }`}
                        onClick={() =>
                          updateSelectedQuery({ ...selectedQuery, queryType: query.value })
                        }>
                        <Typography className={classes.consultationCardText}>
                          {query.label}
                        </Typography>
                      </div>
                    ))}
                  </div>

                  {/* Définir le poste */}
                  {(selectedQuery.queryType === 'cover-letter' ||
                    selectedQuery.queryType === 'interview-preparation') && (
                    <div className={classes.formField}>
                      <Typography className={classes.formLabel}>Définir le poste</Typography>
                      <textarea
                        className={classes.contextTextarea}
                        placeholder="Veuillez définir le poste"
                        value={selectedQuery.jobPosition || ''}
                        onChange={e =>
                          updateSelectedQuery({ ...selectedQuery, jobPosition: e.target.value })
                        }
                      />
                    </div>
                  )}

                  <div className={classes.formField}>
                    <Typography className={classes.formLabel}>Importer le CV</Typography>
                    <div className={classes.cvUploadContainer}>
                      <input
                        type="file"
                        id="cv-upload"
                        accept=".pdf"
                        style={{ display: 'none' }}
                        onChange={handleFileInputChange}
                      />

                      {cvFile && cvFile.name ? (
                        // File display view
                        <div className={classes.cvFileDisplay}>
                          <div className={classes.cvFileIcon}>
                            <ExportIcon style={{ width: 20, height: 20 }} />
                          </div>
                          <Typography className={classes.cvFileName}>{cvFile.name}</Typography>
                          <div className={classes.cvFileDelete} onClick={removeFile}>
                            <TrashIcon style={{ width: 16, height: 16 }} />
                          </div>
                        </div>
                      ) : (
                        // Upload area
                        <div
                          className={`${classes.cvUploadBox} ${
                            isDragOver ? classes.cvUploadBoxDragOver : ''
                          }`}
                          onClick={() => document.getElementById('cv-upload')?.click()}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}>
                          <div className={classes.cvUploadIcon}>
                            <ImportIcon style={{ width: 24, height: 24, color: '#9799B1' }} />
                          </div>
                          <Typography className={classes.cvUploadText}>
                            Cliquez ou faites glisser ici pour télécharger
                          </Typography>
                          <Typography className={classes.cvUploadFormatText}>
                            Format accepté : PDF (max. 2Mo)
                          </Typography>
                        </div>
                      )}

                      {fileError && (
                        <Typography className={classes.cvUploadError}>{fileError}</Typography>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Bottom Container - pushed to bottom */}
          <div className={classes.bottomContainer}>
            {/* Step 1 Bottom Content */}
            {currentStep === 1 && (
              <>
                {/* Bottom Message */}
                <Typography className={classes.bottomMessage}>
                  {testStatus?.message || "Chargement de l'état des tests..."}
                </Typography>

                {/* Action Buttons */}
                {testStatus?.canCreateConsultation ? (
                  <div className={classes.buttonContainer}>
                    <Button
                      className={`${classes.baseButton} ${classes.secondaryButton}`}
                      onClick={handleUpdateInformation}>
                      Mettre à jour les informations
                    </Button>
                    <Button
                      className={`${classes.baseButton} ${classes.primaryButton}`}
                      onClick={() => {
                        setCurrentStep(4);
                      }}>
                      Continuer, sans modification
                    </Button>
                  </div>
                ) : (
                  <div className={classes.buttonContainer}>
                    <Button
                      className={`${classes.baseButton} ${classes.actionButton} ${classes.mAuto}`}
                      onClick={callBackDrawer}>
                      Retourner à l&apos;utilisateur
                    </Button>
                  </div>
                )}
              </>
            )}

            {currentStep === 2 && (
              <ConsultationNavigation
                currentStep={currentStep}
                canContinue={validation.step2}
                onBack={() => setCurrentStep(1)}
                // onContinue={() => setCurrentStep(3)}
                onContinue={() => saveBeneficiaryInfo()}
                classes={classes}
              />
            )}

            {currentStep === 3 && (
              <ConsultationNavigation
                currentStep={currentStep}
                canContinue={validation.step3}
                onBack={() => setCurrentStep(2)}
                onContinue={() => setCurrentStep(4)}
                classes={classes}
              />
            )}

            {currentStep === 4 && (
              <ConsultationNavigation
                currentStep={currentStep}
                canContinue={validation.step4}
                onBack={() => setCurrentStep(3)}
                onContinue={() => setCurrentStep(5)}
                classes={classes}
              />
            )}

            {currentStep === 5 && (
              <ConsultationNavigation
                currentStep={currentStep}
                canContinue={validation.step5}
                onBack={() => setCurrentStep(4)}
                onContinue={() => setCurrentStep(6)}
                classes={classes}
              />
            )}

            {currentStep === 6 && (
              <ConsultationNavigation
                currentStep={currentStep}
                canContinue={validation.step6}
                onBack={() => setCurrentStep(5)}
                onContinue={async () => {
                  if (!cvFile) {
                    setFileError('Veuillez importer un CV');
                    return;
                  }
                  setIsSubmitting(true);
                  try {
                    // Submit consultation and get the ID from backend response
                    const identityData = await userService.getBeneficiaryById({
                      userId: beneficiaryId,
                      token,
                      needTestDone: false,
                    });

                    const { consultationId } = await aiService.submitConsultation(
                      consultationData,
                      identityData.data,
                      cvFile
                    );

                    // Clear consultation data from storage after successful submission
                    clearConsultation();

                    // Navigate to the new consultation page with ID from backend
                    history.push(
                      `/admin/assistant-ia/${beneficiaryId}/consultation/${consultationId}`
                    );
                  } catch (error) {
                    console.error('Error submitting consultation:', error);
                    alert.openSimpleAlert(
                      'Erreur lors de la soumission de la consultation. Veuillez réessayer.'
                    );
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
                continueText="Continuer"
                classes={classes}
                isLoading={isSubmitting}
              />
            )}
          </div>
        </div>
      </DrawerRight>
    </Layout>
  );
};

export default withWidth()(ResultatBeneficiaire);
function openSnackbar(arg0: string) {
  throw new Error('Function not implemented.');
}
